export default "__VITE_ASSET__CeQJz0Km__"